import DropdownSelect from "@components/WebsiteRevamp/Dropdown/DropdownSelect"
import LanguageSwitcherIcon from "@components/WebsiteRevamp/icons/LanguageSwitcherIcon"
import {useRouter} from "next/router"
import React from "react"

import styles from "./LanguageSwitcher.module.scss"

type Props = {
	isShown: number
	setIsShown: (id: number) => void
	activeContext?: "desktop" | "mobile"
}

const LanguageSwitcher: React.FC<Props> = ({
	isShown,
	setIsShown,
	activeContext = "desktop",
}) => {
	const router = useRouter()
	const {locale} = router

	const languages = [
		{code: "en", name: "English"},
		{code: "fi", name: "Finnish"},
		{code: "se", name: "Swedish"},
		{code: "da", name: "Danish"},
		{code: "no", name: "Norwegian"},
		{code: "nl", name: "Dutch"},
		{code: "de", name: "German"},
		{code: "is", name: "Icelandic"},
	]

	const options = languages.map((lang) => ({
		key: lang.code,
		render: lang.name,
		onClick: async () =>
			await router
				.push(router.pathname, router.asPath, {locale: lang.code})
				.then(() => setIsShown(-1)),
		className: lang.code === locale ? styles.active : "",
	}))

	return (
		<DropdownSelect
			id={-3}
			isShown={isShown}
			setIsShown={setIsShown}
			options={options}
			buttonContent={
				<LanguageSwitcherIcon className={styles.languageIcon} />
			}
			activeContext={activeContext}
			className={styles.selectMenu}
			optionClassName={styles.option}
			selectedOptionClassName={styles.selectedOption}
		/>
	)
}

export default LanguageSwitcher
